module.exports = __webpack_public_path__ + "img/sprint-first-icon.e723705d.svg";